/**
 * Created by mimadmin on 4/19/2017.
 */
export class ObjectTypeDescription {
  id: string;
  displayname: string;
  description: string;
  systemname: string;
}
